import { putChangeStatusLandings } from '../api/putChangeStatusLandings';
import { setGetLandingsById } from './setGetLandingsById';

export const setPutChangeStatusLandings = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await putChangeStatusLandings(params);
            
            alert('Сохранено')
            dispatch(setGetLandingsById(params));
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}